import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sym from '../components/Sym';

/**
 * CTA de cierre del home. Copy del diseño con el ajuste §4.1: fuera "Sin tarjeta"
 * (la prueba SÍ pide tarjeta al inicio, sin cobro durante los 15 días).
 */
const CTA2 = () => {
  const navigate = useNavigate();
  return (
    <section style={{ maxWidth: 1200, margin: '0 auto', padding: '20px clamp(20px,5vw,40px) clamp(56px,8vw,104px)' }}>
      <div style={{ position: 'relative', overflow: 'clip', background: 'linear-gradient(120deg,#2F6BFF,#132C74)', borderRadius: 30, padding: 'clamp(36px,5vw,72px)', textAlign: 'center' }}>
        <div style={{ position: 'absolute', top: -80, right: -40, width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle,rgba(159,190,255,.45),transparent 62%)', filter: 'blur(8px)' }} />
        <h2 style={{ position: 'relative', font: "600 clamp(2rem,4.5vw,3.2rem)/1.05 'Source Serif 4'", color: '#fff', margin: '0 auto', maxWidth: 660, textWrap: 'balance' }}>
          ¿Listo para dejar de repartir recibos a mano?
        </h2>
        <p style={{ position: 'relative', font: "400 1.15rem/1.55 'Hanken Grotesk'", color: '#D5DEFA', margin: '16px auto 30px', maxWidth: 520 }}>
          Da de alta tu empresa en dos minutos y estrena tus 15 días de prueba.
        </p>
        <a
          onClick={() => navigate('/register')}
          style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', gap: 9, background: '#fff', color: '#14213D', font: "700 1.08rem 'IBM Plex Mono'", padding: '17px 30px', borderRadius: 13, cursor: 'pointer', boxShadow: '0 16px 34px -12px rgba(0,0,0,.5)', transition: 'transform .18s' }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
        >
          Comienza tu prueba de 15 días<Sym name="arrow_forward" size={20} />
        </a>
      </div>
    </section>
  );
};

export default CTA2;
